import { annotations } from '@esentai/core/features/productView/serializer';

import { createPageSerializer } from '@/serializers';

const serializer = createPageSerializer({
  ...annotations,
});

export default serializer;
